import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qcqvf6ftyr: FaireBrandEntity = {
  token: "b_qcqvf6ftyr",
  type: "brand",
  name: "AZSHOP Trading LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/7b2f7cd5616256389d8ec8d467980a44890c3b82a0d71cf741db799bbe49a3ad.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/14f4754d3b97324781eb269249d1e29e49dd02af1bb1a017b7a11481dd85c1a1.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7b2f7cd5616256389d8ec8d467980a44890c3b82a0d71cf741db799bbe49a3ad.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/14f4754d3b97324781eb269249d1e29e49dd02af1bb1a017b7a11481dd85c1a1.jpeg",
  location: "Rosemead, CA, USA",
  minimumOrderDollars: 120,
  rating: 4.1,
  reviewCount: 16,
  isInsider: false,
  description:
    "At AZshop, we believe that fashion should not be a luxury, but a lifestyle accessible to everyone. We are dedicated to creating practical, stylish, and high-quality clothing for modern women to express their most authentic and confident selves.\n\nOur designs draw inspiration from fashion trends around the world, combining classic and contemporary elements to create a unique collection of clothing. Whether for everyday wear or special occasions, AZshop offers the perfect choices for you.\n\nWe strive to create a warm, inclusive shopping experience where every customer feels the warmth of home. AZshop is not just a clothing store, but a place to establish genuine connections with our customers. Through our products and services, we aim to add beauty and style to your life.\n\nWherever you are, AZshop is here to accompany you, providing you with the best fashion experience. Thank you for choosing AZshop, let's together create a brighter and more stylish future!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:22.209Z",
    importedBy: "entity-db-cli",
  },
};
